import React, { Component } from 'react';
import { Api } from '../../lib/api';
import './styles.scss';
import { Table, Select } from 'antd';

const LEVEL_TRACE = 'TRACE';
const LEVEL_DEBUG = 'DEBUG';
const LEVEL_INFO = 'INFO';
const LEVEL_WARN = 'WARN';
const LEVEL_ERROR = 'ERROR';
const LEVEL_FATAL = 'FATAL';

const DEFAULT_LOG_LEVEL = LEVEL_WARN;

interface LogPageState {
    currentLogsHidden: boolean;
    currentSystemLogs: Array<{ id: number; date: string; level: string; entry: string }>;
}

class LogPage extends Component<{}, LogPageState> {
    state: LogPageState = {
        currentLogsHidden: false,
        currentSystemLogs: []
    };

    componentDidMount() {
        this.changeLogLevel(DEFAULT_LOG_LEVEL);
    }

    changeLogLevel(level: string) {
        Api.getSystemLogs(level).then((logs: LogPageState['currentSystemLogs']) => {
            if (logs) {
                this.setState({ currentSystemLogs: logs });
            }
        });
    }

    onClick = () => {
        this.setState((state) => ({
            currentLogsHidden: !state.currentLogsHidden
        }));
    };

    render() {
        return (
            <div id="logs-page" className="logs">
                <div className="current-logs-section-header header" onClick={this.onClick}>
                    Current System Logs
                </div>
                <div className="logs-level-section">
                    <div className="title">Log Level</div>
                    <div className="level">
                        <Select
                            className="selector"
                            defaultValue={DEFAULT_LOG_LEVEL}
                            onChange={(value) => this.changeLogLevel(value)}
                        >
                            <Select.Option value={LEVEL_TRACE}>TRACE</Select.Option>
                            <Select.Option value={LEVEL_DEBUG}>DEBUG</Select.Option>
                            <Select.Option value={LEVEL_INFO}>INFO</Select.Option>
                            <Select.Option value={LEVEL_WARN}>WARN</Select.Option>
                            <Select.Option value={LEVEL_ERROR}>ERROR</Select.Option>
                            <Select.Option value={LEVEL_FATAL}>FATAL</Select.Option>
                        </Select>
                    </div>
                </div>
                <div className={'current-logs-section' + (this.state.currentLogsHidden ? ' flex-hide' : '')}>
                    <Table
                        className="table"
                        columns={[
                            { title: 'Date', dataIndex: 'date', className: 'column-date' },
                            { title: 'Level', dataIndex: 'level', className: 'column-level' },
                            { title: 'Entry', dataIndex: 'entry', className: 'column-entry' }
                        ]}
                        dataSource={this.state.currentSystemLogs}
                        rowKey="id"
                        pagination={{ pageSize: 15, className: 'paginator' }}
                    />
                </div>
                <div className="current-system-logs-section"></div>
            </div>
        );
    }
}

export default LogPage;
